import React from 'react';
import cn from 'classnames';
import { bool, func, number, string, arrayOf, shape } from 'prop-types';

import Results from './layout';
import styles from './styles.module.scss';

function ResultsContainer({ onResultSelect, maxResults, loading, isOpen, results, onMouseOver, onMouseOut }) {
  return (
    <div
      className={cn('full-width', styles.results, { [styles.active]: isOpen })}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}>
      <Results onResultSelect={onResultSelect} maxResults={maxResults} results={results} loading={loading} />
    </div>
  );
}

ResultsContainer.propTypes = {
  results: arrayOf(
    shape({
      placeId: string
    })
  ).isRequired,
  onMouseOut: func.isRequired,
  onMouseOver: func.isRequired,
  onResultSelect: func.isRequired,
  isOpen: bool,
  loading: bool,
  maxResults: number
};

export default ResultsContainer;
